import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "./shared";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      data-testid="floating-whatsapp-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Entre em contato conosco pelo WhatsApp"
      initial={{ opacity: 0, y: 40, scale: 0.8 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-black font-bold px-5 py-3.5 rounded-full shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform duration-200 hover:scale-105 active:scale-95"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping-dot absolute inline-flex h-full w-full rounded-full bg-black/50" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-black/70" />
      </span>
      <MessageCircle size={20} strokeWidth={2.5} />
      <span className="hidden sm:inline text-sm">Entre em contato conosco</span>
    </motion.a>
  );
}
